export const TOKEN_TYPE = {
  DEFAULT: "default",
  STABLECOIN: "stablecoin",
};

export const supportTokenList = {
  name: "BWS Supported Tokens",
  version: "1.0.0",
  tokens: [
    {
      chainId: 43114,
      contractDecimal: 8,
      contractTickerSymbol: "WBTC.e",
      contractName: "Wrapped Bitcoin",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x50b7545627a5162F82A992c33b87aDc75187B218/logo.png",
      contractAddress: "0x50b7545627a5162f82a992c33b87adc75187b218",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "WETH.e",
      contractName: "Wrapped Ether",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB/logo.png",
      contractAddress: "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 6,
      contractTickerSymbol: "USDT.e",
      contractName: "Tether USD",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xc7198437980c041c805A1EDcbA50c1Ce5db95118/logo.png",
      contractAddress: "0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
      type: TOKEN_TYPE.STABLECOIN,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "WAVAX",
      contractName: "Wrapped AVAX",
      logoUrl:
        "https://raw.githubusercontent.com/sushiswap/icons/master/network/avalanche.jpg",
      contractAddress: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "LINK.e",
      contractName: "Chainlink Token",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x5947BB275c521040051D82396192181b413227A3/logo.png",
      contractAddress: "0x5947bb275c521040051d82396192181b413227a3",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 6,
      contractTickerSymbol: "USDC.e",
      contractName: "USD Coin - Bridged",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664/logo.png",
      contractAddress: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664",
      type: TOKEN_TYPE.STABLECOIN,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "CRA",
      contractName: "Crabada Token",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xA32608e873F9DdEF944B24798db69d80Bbb4d1ed/logo.png",
      contractAddress: "0xA32608e873F9DdEF944B24798db69d80Bbb4d1ed",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "JOE",
      contractName: "TraderJoe Token",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd/logo.png",
      contractAddress: "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "PTP",
      contractName: "Platypus",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0x22d4002028f537599bE9f666d1c4Fa138522f9c8/logo.png",
      contractAddress: "0x22d4002028f537599bE9f666d1c4Fa138522f9c8",
      type: TOKEN_TYPE.DEFAULT,
    },
    {
      chainId: 43114,
      contractDecimal: 18,
      contractTickerSymbol: "DAI.e",
      contractName: "Dai Stablecoin",
      logoUrl:
        "https://raw.githubusercontent.com/traderjoe-xyz/joe-tokenlists/main/logos/0xd586E7F844cEa2F87f50152665BCbc2C279D8d70/logo.png",
      contractAddress: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
      type: TOKEN_TYPE.STABLECOIN,
    },
  ],
};

export default supportTokenList;
